<template>
<div>
<ContentHeader title="Soru Listesi Koşulları"  url="NewQuestionlistcondition" :show_button="true" icon="plus" buttontype="primary" label="Yeni Koşul"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<template v-if="items.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>
<template v-else>


<div class="mt-4">




<ContentTable 
:data="items" 
:columns="columns" 
routename="Questionlistcondition" 
deleteobjectname="questionlists_condition"   
@dataDeleted="getData"  
identifier_row_name="condition_id"
:sortable="true" 
@rowsReorders="listupdated"
></ContentTable>



</div>

</template>


</template>


</div>	
</template>
<script>
export default {

  name: 'Questionlistconditions',


  data () {
    return {
      items:[],
      loading:true,
      columns:[
      {
        type:"text",       
        with_route:true,
        field:"text",
        header:"Koşul Özeti",
        hide_on_mobile:false,
      },
      ]
    }
  },
  computed:{
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
  },
  watch:{
    deletedstate(newVal,oldVal)
    {
      if(newVal)
      {
        this.getData()
      }
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
      this.loading =  true
      this.items =  []
      let items = await this.generalApiGetWithoutLoader("questionlists_conditions/"+this.$route.params.id)
      for(let item of items)
      {
      	item = await this.resolveCondition(item)
      	this.items.push(item)
      }
      //this.items = await items
      console.log(this.items)
      this.loading = await false
    },
    listupdated(data)  
    {
      console.log(data)
      let arr = []
      data = data.map(item=>item.id)
      for(let item of data)
      {
        let element = this.items.find(condition=>condition.id == item)
        if(element)
        {
          arr.push(element)
        }
      }
      this.items = arr
      let formdata = new FormData()
      formdata.append('list', JSON.stringify(data));
      this.generalSubmission(formdata,"reorder_questionlists_conditions/"+this.$route.params.id,this.afterlistupdated)
    },
    afterlistupdated(response)
    {
      console.log(response.data)
      //this.flows = response.data
    },
     async resolveCondition(item)
	  {
      if(item.reminder)
      {
          return await {
            id:item.id,
            text:item.reminder
          }
      }
	  	let conditions = JSON.parse(item.conditions)
	  	let outcome = JSON.parse(item.outcome)
	  	let first_condition = conditions[0]
	  	let first_outcome = outcome[0]
	  	let condition_inputfield
      let the_type
      
	  	if(first_condition.inputfield_id)
	  	{
	  		condition_inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+first_condition.inputfield_id)
        the_type = " - Soru"

	  	}
	  	if(first_condition.customattribute_id)
      {
        condition_inputfield = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute/"+first_condition.customattribute_id)
        await console.log(condition_inputfield)
        the_type = " - Özel Nitelik"
      }

      if(first_condition.nonconformitytype_id)
      {
        console.log("first_condition")
        console.log(first_condition)
        let nonconformitytypes = await this.generalApiGetWithoutLoader("questionlistnonconformitytypes/"+this.$route.params.id)
        console.log(nonconformitytypes)
        condition_inputfield = nonconformitytypes.find((item)=>{return item.id == first_condition.nonconformitytype_id})
        if(!condition_inputfield)
        {
          condition_inputfield = {name:"Hepsi"}
        }
        await console.log(condition_inputfield)
        the_type = " - Uygunsuzluk"
      }

      if(first_condition.customcalculation_id)
      {
        let customcalculations = await this.generalApiGetWithoutLoader("questionlistsametypecalculations/"+this.$route.params.id)
        condition_inputfield = customcalculations.find((item)=>{return item.id == first_condition.customcalculation_id})
        await console.log(condition_inputfield)
        the_type = " - Özel Hesaplama"
      }
	  	
      /*
	  	let outcome_inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+first_outcome.inputfield_id)
	  	condition_inputfield.name = await condition_inputfield.name.substring(0, 50)+"...";
	  	outcome_inputfield.name = await outcome_inputfield.name.substring(0, 50)+"...";

      */





	  	let text = await condition_inputfield.name+the_type
	  	return await {
	  		id:item.id,
	  		text:text
	  	}
	  },
  },
 
}
</script>

<style lang="css" scoped>
</style>